<template>
  <SlideshowPanel icon="share" :title="forFilm('linkTitle', 'lifeShareTitle')">
    <!-- Phones: the link first, at once; the film to save or post, once it's made. -->
    <div class="slideshow-share-choice">
      <button
        class="slideshow-share-card__copybtn"
        type="button"
        @click="emit('link')"
      >
        <SlideshowIcon name="share" />
        {{ forFilm("linkTitle", "lifeShareTitle") }}
      </button>
      <SlideshowFilmButton
        class="slideshow-share-choice__film"
        :percent="filmPercent"
        :state="filmState"
        @click="emit('film')"
      />
    </div>
  </SlideshowPanel>
</template>

<script lang="ts" setup>
  import { forFilm } from "../../composables/useSlideshow";
  import SlideshowFilmButton from "./SlideshowFilmButton.vue";
  import SlideshowIcon from "./SlideshowIcon.vue";
  import SlideshowPanel from "./SlideshowPanel.vue";

  defineProps<{
    filmPercent: number;
    filmState: "idle" | "making" | "ready";
  }>();
  const emit = defineEmits<{ film: []; link: [] }>();
</script>
